const i = {
  code: "de",
  facebook: "de_DE",
  label: "Deutsch",
  loadingText: "Laden...",
  translations: {
    ar: "Arabisch",
    de: "Deutsch",
    en: "Englisch",
    es: "Spanisch",
    fr: "Französisch",
    he: "Hebräisch",
    hi: "Hindi",
    id: "Indonesisch",
    it: "Italienisch",
    ja: "Japanisch",
    km: "Khmer",
    ko: "Koreanisch",
    lo: "Laotisch",
    ms: "Malaiisch",
    nl: "Niederländisch",
    pt: "Portugiesisch",
    ru: "Russisch",
    th: "Thai",
    tl: "Filipino",
    tr: "Türkisch",
    vi: "Vietnamesisch",
    "zh-CN": "Chinesisch (ver.)",
    "zh-TW": "Chinesisch (trad.)"
  }
};
export {
  i as german
};
